
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanModel } from './Entities.Accounting.AccountingPlan';
import { LedgerHeaderModel } from './Entities.Accounting.LedgerHeader';
import { LedgerPostType } from 'enums/LedgerPostType';
import { BcDocumentLineType } from 'enums/BcDocumentLineType';
import { BillingDocumentLineModel } from './Accounting.IntegrationAbstractions.BillingDocumentLine';
import { Model, ModelProperty } from 'models/Model';


export class LedgerPostModel extends Model<LedgerPostModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'ledgerPost.property.id', isHidden: true },
		{ name: 'ledgerHeaderId', type: 'guid', languageString: 'ledgerPost.property.ledgerHeaderId' },
		{ name: 'accountingPlanId', type: 'guid', languageString: 'ledgerPost.property.accountingPlanId' },
		{ name: 'lineNumber', type: 'number', languageString: 'ledgerPost.property.lineNumber' },
		{ name: 'plannedDate', type: 'Date', languageString: 'ledgerPost.property.plannedDate' },
		{ name: 'value', type: 'number', languageString: 'ledgerPost.property.value' },
		{ name: 'creditedPostedDocumentNo', type: 'string', languageString: 'ledgerPost.property.creditedPostedDocumentNo' },
		{ name: 'creditedLineNumber', type: 'number', languageString: 'ledgerPost.property.creditedLineNumber' },
		{ name: 'productPlanId', type: 'guid', languageString: 'ledgerPost.property.productPlanId' },
		{ name: 'lineTypeNumber', type: 'string', languageString: 'ledgerPost.property.lineTypeNumber' },
		{ name: 'description', type: 'string', languageString: 'ledgerPost.property.description' },
		{ name: 'productDimension', type: 'string', languageString: 'ledgerPost.property.productDimension' },
		{ name: 'salesTypeDimension', type: 'string', languageString: 'ledgerPost.property.salesTypeDimension' },
		{ name: 'departmentDimension', type: 'string', languageString: 'ledgerPost.property.departmentDimension' },
		{ name: 'companyDimension', type: 'string', languageString: 'ledgerPost.property.companyDimension' },
		{ name: 'accountingPlan', type: 'AccountingPlanModel', languageString: 'ledgerPost.property.accountingPlan', isHidden: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } },
		{ name: 'ledgerHeader', type: 'LedgerHeaderModel', languageString: 'ledgerPost.property.ledgerHeader', isHidden: true, isObject: true, new: () => { return new LedgerHeaderModel }, properties: () => { return LedgerHeaderModel.classProperties } },
		{ name: 'type', type: 'LedgerPostType', languageString: 'ledgerPost.property.type' },
		{ name: 'lineType', type: 'BcDocumentLineType', languageString: 'ledgerPost.property.lineType' },
		{ name: 'subtractValue', type: 'boolean', languageString: 'ledgerPost.property.subtractValue' },
		{ name: 'signedValue', type: 'number', languageString: 'ledgerPost.property.signedValue' },
		{ name: 'isInvoice', type: 'boolean', languageString: 'ledgerPost.property.isInvoice' },
		{ name: 'isCreditMemo', type: 'boolean', languageString: 'ledgerPost.property.isCreditMemo' },
		{ name: 'isRegistered', type: 'boolean', languageString: 'ledgerPost.property.isRegistered' },
		{ name: 'isFutureInvoice', type: 'boolean', languageString: 'ledgerPost.property.isFutureInvoice' },
		{ name: 'isEditable', type: 'boolean', languageString: 'ledgerPost.property.isEditable' },
		{ name: 'isClick', type: 'boolean', languageString: 'ledgerPost.property.isClick' },
		{ name: 'documentLine', type: 'BillingDocumentLineModel', languageString: 'ledgerPost.property.documentLine', isHidden: true, isObject: true, new: () => { return new BillingDocumentLineModel }, properties: () => { return BillingDocumentLineModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public ledgerHeaderId?: string;
	public accountingPlanId?: string;
	public lineNumber?: number;
	public plannedDate?: Date;
	public value: number;
	public creditedPostedDocumentNo: string;
	public creditedLineNumber?: number;
	public productPlanId?: string;
	public lineTypeNumber: string;
	public description: string;
	public productDimension: string;
	public salesTypeDimension: string;
	public departmentDimension: string;
	public companyDimension: string;
	public accountingPlan?: AccountingPlanModel;
	public ledgerHeader?: LedgerHeaderModel;
	public type: LedgerPostType;
	public lineType?: BcDocumentLineType;
	public subtractValue: boolean;
	public signedValue: number;
	public isInvoice: boolean;
	public isCreditMemo: boolean;
	public isRegistered: boolean;
	public isFutureInvoice: boolean;
	public isEditable: boolean;
	public isClick: boolean;
	public documentLine?: BillingDocumentLineModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.ledgerHeaderId = undefined;
		this.accountingPlanId = undefined;
		this.lineNumber = undefined;
		this.plannedDate = undefined;
		this.value = 0;
		this.creditedPostedDocumentNo = '';
		this.creditedLineNumber = undefined;
		this.productPlanId = undefined;
		this.lineTypeNumber = '';
		this.description = '';
		this.productDimension = '';
		this.salesTypeDimension = '';
		this.departmentDimension = '';
		this.companyDimension = '';
		this.accountingPlan = undefined;
		this.ledgerHeader = undefined;
		this.type = 0;
		this.lineType = undefined;
		this.subtractValue = false;
		this.signedValue = 0;
		this.isInvoice = false;
		this.isCreditMemo = false;
		this.isRegistered = false;
		this.isFutureInvoice = false;
		this.isEditable = false;
		this.isClick = false;
		this.documentLine = undefined;
		
	}
	getProperties(){
		return LedgerPostModel.classProperties;
	}
}

